export class CompleteActivitySignatureContainerData {
    requestId: number;
    activityId: number;
    merchantMember: string;
    merchantEmail: string;
    signatureData: string;
}